module.exports = __webpack_public_path__ + "img/icon_close.4a09dc83.png";